import { render, staticRenderFns } from "./UserDetailsCard.vue?vue&type=template&id=224e2aec"
import script from "./UserDetailsCard.vue?vue&type=script&lang=js"
export * from "./UserDetailsCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports